import React, { useState } from 'react'
import {
	Modal,
	ModalSection,
	Row,
	Typography,
	PrimaryButton,
} from '@copyrightagent/basic-components'
import { Button, TextareaAutosize } from '@material-ui/core'
import { uploadRegisteredImages } from '../api'
import { toast } from '../../../../store/utils'
import globalUseStyle from '../style'
import useStyle from './UploadImagesModalStyle'
import { useRegistrationCertificatesStore } from '../stores/registrationCertificateStore'
import { useRegisteredImagesStore } from '../stores/registeredImagesStore'

export const UploadImagesModal = () => {
	const {
		fetchRegisteredImages,
		uploadImagesModalOpen,
		setUploadImagesModalOpen,
		selectedRegistrationCertificate,
		setSearchString,
	} = useRegisteredImagesStore()

	const registrationCertificatesStore = useRegistrationCertificatesStore()
	const globalClasses = globalUseStyle()
	const classes = useStyle()

	const [uploading, setUploading] = useState(false)
	const [partnerImageIdsString, setPartnerImageIdsString] = useState<string>('')

	const handleClose = () => {
		setUploadImagesModalOpen(false)
	}

	const submitRegisteredImages = async () => {
		setUploading(true)

		const partnerImageIds = partnerImageIdsString
			.split('\n')
			.flatMap((line) => line.split(','))
			.filter(Boolean)

		const response = await uploadRegisteredImages({
			partnerImageIds,
			registrationCertificateId:
				selectedRegistrationCertificate!.registration_certificate_id,
		})
		setUploading(false)
		if (response.isSuccessful) {
			setSearchString('')
			fetchRegisteredImages(
				selectedRegistrationCertificate!.registration_certificate_id,
				{
					isInitialLoad: true,
				},
			)
			const foundRegistrationCertificate =
				registrationCertificatesStore.registrationCertificates.find(
					(registrationCertificate) =>
						registrationCertificate.registration_certificate_id ===
						selectedRegistrationCertificate!.registration_certificate_id,
				)

			if (foundRegistrationCertificate) {
				registrationCertificatesStore.incrementRegistrationCertificateImageCount(
					{
						registrationCertificateId:
							selectedRegistrationCertificate!.registration_certificate_id,
						incrementImageCountBy: partnerImageIds.length,
					},
				)
			}
			setPartnerImageIdsString('')
			await toast('Image IDs successfully added.', 'success')
		} else {
			await toast('Something went wrong. Please try again later', 'error')
		}
	}

	const handleCancel = () => {
		setPartnerImageIdsString('')
		handleClose()
	}

	return (
		<Modal
			open={uploadImagesModalOpen}
			onClose={handleClose}
			title={`Upload Image IDs to ${
				selectedRegistrationCertificate!.registration_certificate_id
			}`}
			titleText={
				'Manually type in images, seperated either by a comma or by a new line, or both!'
			}
			size="large"
		>
			<ModalSection>
				<TextareaAutosize
					value={partnerImageIdsString}
					onChange={(e) => setPartnerImageIdsString(e.target.value)}
					className={classes.textArea}
				/>
			</ModalSection>
			<ModalSection>
				<Row justify="flex-end">
					<Button
						className={globalClasses.invisibleButton}
						onClick={handleCancel}
					>
						<Typography>Cancel</Typography>
					</Button>
					<PrimaryButton
						type="submit"
						loading={uploading}
						text={'Upload Images'}
						loadingText={'Uploading Images'}
						onClick={submitRegisteredImages}
						disabled={uploading || !partnerImageIdsString}
					/>
				</Row>
			</ModalSection>
		</Modal>
	)
}
